import React, { Component } from "react";
import Select from "../../../components/Select";
import auth from "../../../utils/auth";
import GenericInputDate from "../../../components/GenericInputDate";
class Configuracao extends Component {
    userInfo = auth.getUserInfo()

    handleChangePeriodo = (objectDate) => {
        let detalhes = Object.assign({}, this.props.detalhes)
        detalhes["periodo"] = {
            data_inicio: objectDate.startDate,
            data_fim: objectDate.endDate
        }

        this.props.setDetalhes(detalhes)
    }

    handleChangeHora = (e) => {
        let detalhes = Object.assign({}, this.props.detalhes)
        let periodo = detalhes["periodo_hora"] || {}

        const id = e.target.id
        periodo[id] = e.target.value
        detalhes["periodo_hora"] = periodo

        this.props.setDetalhes(detalhes)
    }

    handleInput = (key, value) => {
        let detalhes = Object.assign({}, this.props.detalhes)
        detalhes[key] = value
        this.props.setDetalhes(detalhes)
    }

    render() {
        return (
            this.props.edit ? 
                <details open={true} className='custom-summary' data-tour="exportacao-filtros">
                    <summary>Filtros</summary>
                    <div style={{ padding: "20px" }} className="hdv-form-default">
                        <div className="row">
                            <div className="col-md-4" data-tour="exportacao-descricao">
                                <label style={{marginTop: "0px"}} className="required">Descrição</label>
                                <input value={this.props.detalhes.descricao ?? ""} onChange={(e) => this.handleInput("descricao", e.target.value)} id="descricao" type="text" />
                                {!this.props.validacao.descricao ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                            </div>
                            <div className="col-md-4" data-tour="exportacao-periodo">
                                <label className="required mt-0">Periodo</label>
                                <GenericInputDate onChange={(objectDate) => this.handleChangePeriodo(objectDate)} haveInitialValue/>
                                {!this.props.validacao.periodo ? <span id='validacao-periodo'>Campo Obrigatório</span> : null}
                            </div>
                            <div className="col-md-2" data-tour="exportacao-hora-inicio">
                                <label className="required mt-0">Início</label>
                                <input value={this.props.detalhes?.periodo_hora?.inicio ?? "00:00"} onChange={(e) => this.handleChangeHora(e)} className="w-100" id="inicio" type="time" />
                            </div>
                            <div className="col-md-2" data-tour="exportacao-hora-fim">
                                <label className="required mt-0">Fim</label>
                                <input value={this.props.detalhes?.periodo_hora?.fim ?? "23:59"} onChange={(e) => this.handleChangeHora(e)} className="w-100" id="fim" type="time" />
                            </div>
                        </div>
                    </div>
                </details>
            :
               <div className="hdv-form-default">
                    <div style={{alignItems: "baseline"}} className="row">
                        <div className="col-md-8" data-tour="exportacao-descricao">
                            <label style={{marginTop: "0px"}} className="required">Descrição</label>
                            <input value={this.props.detalhes.descricao ?? ""} onChange={(e) => this.handleInput("descricao", e.target.value)} id="descricao" type="text" />
                            {!this.props.validacao.descricao ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                        </div>

                        {
                            this.userInfo?.tipo != "cliente" ?
                                <div className="col-md-4 pl-0" data-tour="exportacao-cliente">
                                    <label>Cliente</label>
                                    <Select
                                        value={this.props.detalhes.cliente}
                                        onChange={(e) => this.handleInput('cliente', e)}
                                        options={this.props.clientes}
                                    />
                                </div>
                            : null
                        }
                    </div>
               </div>
        )
    }
}

export default Configuracao